import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class Footer extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {

    if(this.props.data){
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }

    return (
      <footer>

     <div className="row">
        <div className="twelve columns">
           <ul className="social-links">
              {networks}
           </ul>
            <Link to='/privacy' target='_blank'>Privacy </Link>
            <Link to='/impressum' target='_blank'> Impressum</Link>
           <ul className="copyright">
              <li>&copy; Copyright 2023 Mannheim Urology</li>
           </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
  </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js